export let KeyEventType;(function(e){e[e["UP"]=0]="UP";e[e["DOWN"]=1]="DOWN"})(KeyEventType||(KeyEventType={}));